import { useGoogleLogin } from "@react-oauth/google";
import { HttpStatusCode } from "axios";
import Button from "@mui/material/Button";
import googleLogo from '../../../assets/images/logos/google.svg'
import { axiosHttp } from "../../../AxiosWrapper";
import { useAuthentication } from "../../../context/AuthenticationProvider";
import { AvatarUtil } from "../../../utils/CommonUtil";

const GoogleLoginView = () => {

    const { logedInSuccess, closeLoginModal } = useAuthentication();

    const login = useGoogleLogin({
        onSuccess: credentialResponse => verifyResponse(credentialResponse),
        onError: () => console.log('Login Failed'),
    });

    const verifyResponse =(response)=>{
        axiosHttp.post("/api/pub/dss/v1/signIn", { provider: "GOOGLE",accessToken:response.access_token, avatar: AvatarUtil.getAvatarColor()})
                    .then((response) => {
                        if (response.data.status === HttpStatusCode.Ok) {
                            logedInSuccess(response.data.content);
                        }
                    })
                    .catch((error) => { })
                    .then((res) => {
                    })
    }


    return (
        <Button variant="outlined" sx={{ px: 4,py:1.5, borderRadius: 2 }} onClick={() => {
            closeLoginModal();
            login();
        }}> 
        <img src={googleLogo}/>
       {/* <GoogleIcon /> */}
        </Button>
    );
};

export default GoogleLoginView;